export default __webpack_public_path__ + "static/media/logo_comercial.48278d97.svg";